export function trackEvent(name, params = {}) {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }

  window.gtag("event", name, params);
}

export const trackCta = (name, label, location) =>
  trackEvent(name, {
    event_category: "cta",
    event_label: label,
    location,
  });
